import * as React from 'react';

import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { buildHashWithAuthMode, getLocationHash } from 'js/lib/authModeDeepLinkUtils';
import requestCountry from 'js/lib/requestCountry';
import user from 'js/lib/user';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';

import 'css!bundles/acclaim/styl/index';

type Props = {
  // always injected by the connectToStores wrapper below
  requestCountryCode: string;
  // always injected by the connectToStores wrapper below (store value may be null/undefined)
  csrfToken: string | null | undefined;
};

class AcclaimApp extends React.LegacyComponentWithChildren<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof AcclaimApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  getChildContext() {
    return {
      csrfToken: this.props.csrfToken,
      requestCountryCode: this.props.requestCountryCode,
    };
  }

  componentDidMount() {
    if (!user.isAuthenticatedUser()) {
      const { router } = this.context;
      router.replace({
        pathname: router.location.pathname,
        query: omit({ ...router.location.query }, 'authMode'),
        hash: buildHashWithAuthMode(getLocationHash(router.location), 'login'),
      });
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div className="rc-AcclaimApp">
        <DefaultHeader showMetaNav />
        <UniversalPageFeatures />
        {user.isAuthenticatedUser() && children}
      </div>
    );
  }
}

export default connectToStores(AcclaimApp, ['ApplicationStore'], (context, props) => ({
  ...props,
  csrfToken: context.ApplicationStore.getState().csrfToken,
  requestCountryCode: requestCountry.get(),
}));
